// This is a constant GUID that identifies the default segment across all organizations.
// Any organization with this GUID has it designated as their default segment.
export const DefaultSegmentGuid = '3516a6ba-c998-4bfb-9017-322f8cf63674';
